module.exports = __webpack_public_path__ + "img/transporte.14ec9770.svg";